import React, { useEffect, useState } from "react";
import AppModal from "./AppModal";

const StaffModal = ({ show, setShow, editData = null }) => {
  const isEdit = editData !== null;
  const [preview, setPreview] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    role: "",
    department: "",
    joining_date: "",
    salary: "",
    address: "",
    status: "",
    password: "",
    image: null,
  });

  // Set Edit Data
  useEffect(() => {
    if (editData) {
      setFormData({
        name: editData.name || "",
        email: editData.email || "",
        mobile: editData.mobile || "",
        role: editData.role || "",
        department: editData.department || "",
        joining_date: editData.joining_date || "",
        salary: editData.salary || "",
        address: editData.address || "",
        status: editData.status || "",
        password: editData.password || "",
        image: null,
      });
      setPreview(editData.image || "");
    } else {
      // Reset Form
      setFormData({
        name: "",
        email: "",
        mobile: "",
        role: "",
        department: "",
        joining_date: "",
        salary: "",
        address: "",
        status: "",
        password: "",
        image: null,
      });
      setPreview("");
    }
  }, [editData, show]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setFormData({
        ...formData,
        image: file,
      });

      setPreview(URL.createObjectURL(file));
    }
  };

  // Handle Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Submit
  const handleSubmit = () => {
    if (isEdit) {
      console.log("Update Staff", formData);
    } else {
      console.log("Add Staff", formData);
    }

    setShow(false);
  };

  return (
    <AppModal
      show={show}
      setShow={setShow}
      title={isEdit ? "Edit Staff" : "Add Staff"}
      size="modal-lg"
      footer={
        <>
          <button className="btn btn-danger" onClick={() => setShow(false)}>
            Cancel
          </button>

          <button className="btn btn-primary" onClick={handleSubmit}>
            {isEdit ? "Update Staff" : "Save Staff"}
          </button>
        </>
      }
    >
      <div className="row">
        <div className="col-md-12 mb-3">
          <label className="form-label">Staff Image</label>

          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={handleImageChange}
          />
        </div>

        {preview && (
          <div className="col-md-12 mb-3">
            <img
              src={preview}
              alt="Preview"
              width="120"
              height="120"
              className="rounded border object-fit-cover"
            />
          </div>
        )}
        {/* Name */}
        <div className="col-md-6 mb-3">
          <label className="form-label">Full Name</label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter full name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
        </div>

        {/* Email */}
        <div className="col-md-6 mb-3">
          <label className="form-label">Email Address</label>

          <input
            type="email"
            className="form-control"
            placeholder="Enter email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </div>

        {/* Mobile */}
        <div className="col-md-6 mb-3">
          <label className="form-label">Mobile Number</label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter mobile number"
            name="mobile"
            maxLength={10}
            value={formData.mobile}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");

              setFormData({
                ...formData,
                mobile: value,
              });
            }} 
          />
        </div>

        {/* Role */}
        <div className="col-md-6 mb-3">
          <label className="form-label">Role</label>

          <select
            className="form-select"
            name="role"
            value={formData.role}
            onChange={handleChange}
          >
            <option value="">Select Role</option>

            <option value="Admin">Admin</option>

            <option value="Manager">Manager</option>

            <option value="Developer">Developer</option>

            <option value="Designer">Designer</option>
          </select>
        </div>

        {/* Department */}
        <div className="col-md-6 mb-3">
          <label className="form-label">Department</label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter department"
            name="department"
            value={formData.department}
            onChange={handleChange}
          />
        </div>

        {/* Joining Date */}
        <div className="col-md-6 mb-3">
          <label className="form-label">Joining Date</label>

          <input
            type="date"
            className="form-control"
            name="joining_date"
            value={formData.joining_date}
            onChange={handleChange}
          />
        </div>

        {/* Salary */}
        <div className="col-md-6 mb-3">
          <label className="form-label">Salary</label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter salary"
            name="salary"
            maxLength={10}
            value={formData.salary}
            onChange={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              setFormData({
                ...formData,
                salary: value,
              });
            }}
          />
        </div>

        {/* Status */}
        <div className="col-md-6 mb-3">
          <label className="form-label">Status</label>

          <select
            className="form-select"
            name="status"
            value={formData.status}
            onChange={handleChange}
          >
            <option value="">Select Status</option>

            <option value="Active">Active</option>

            <option value="Inactive">Inactive</option>
          </select>
        </div>

        {/* Password */}
        {!isEdit && (
          <div className="col-md-12 mb-3">
            <label className="form-label">Password</label>

            <input
              type="password"
              className="form-control"
              placeholder="Enter password"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />
          </div>
        )}

        {/* Address */}
        <div className="col-md-12 mb-3">
          <label className="form-label">Address</label>

          <textarea
            rows="4"
            className="form-control"
            placeholder="Enter address"
            name="address"
            value={formData.address}
            onChange={handleChange}
          ></textarea>
        </div>

        {/* Permissions */}
        <div className="col-md-12">
          <label className="form-label">Staff Permissions</label>

          <div className="row">
            {[
              "Lead",
              "Task",
              "Reminder",
              "Meeting",
              "Invoice",
              "Global Search",
              "Copy Lead",
              "Accounting",
              "Quotation",
              "Todo",
              "Chat",
              "Holiday",
              "Attendance",
              "Leave",
              "Staff",
              "Department",
            ].map((permission, index) => (
              <div className="col-md-2 col-4" key={index}>
                <div className="d-flex flex-column gap-2">
                  <label className="fw-medium small">{permission}</label>

                  <div className="form-check form-switch pb-0">
                    <input
                      className="form-check-input custom-switch"
                      type="checkbox"
                      role="switch"
                      id={`permission-${index}`}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </AppModal>
  );
};

export default StaffModal;
